<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8">
          <div v-if="storeError" class="card card-inverse card-warning">
            <div class="card-header">
              Warning
            </div>
            <div class="card-block">
              {{ storeError }}
            </div>
          </div>
          <div class="card-group mb-0">
            <div class="card p-4">
              <div class="card-block">
                <form @submit="login">
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <div class="input-group mb-3">
                    <span class="input-group-addon"><i class="icon-user" /></span>
                    <input
                      v-model="username"
                      type="email"
                      class="form-control"
                      placeholder="Username"
                    >
                  </div>
                  <div class="input-group mb-4">
                    <span class="input-group-addon"><i class="icon-lock" /></span>
                    <input
                      v-model="password"
                      type="password"
                      class="form-control"
                      placeholder="Password"
                    >
                  </div>
                  <div class="mb-4">
                    <a href="/#/password/reset">Forgot Password</a>
                  </div>

                  <div v-if="recaptchaStorageKey" class="input-group mb-4">
                    <VueRecaptcha
                      ref="recaptcha"
                      size="normal"
                      :sitekey="recaptchaStorageKey"
                      :load-recaptcha-script="true"
                      @verify="onCaptchaVerified"
                      @expired="onCaptchaExpired"
                    />
                  </div>

                  <!-- <div v-if="captchaVerified" class="input-group"> -->
                  <div class="input-group">
                    <button type="button" class="btn btn-primary px-4 login-btn" @click="login">
                      Login
                      <span v-if="loading" class="btn-loader" />
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div class="card card-inverse card-primary py-5 d-md-down-none" style="width:44%">
              <div class="card-block text-center">
                <div>
                  <h2>Sign up</h2>
                  <p>Admin dashboard for the Ellen G. White Estate services.</p>
                </div>
              </div>
            </div>
          </div>
          <div v-if="errors" class="card card-inverse card-danger">
            <div class="card-header">
              Errors
            </div>
            <div class="card-block">
              <div v-html="errors" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import axios from 'axios';
import VueRecaptcha from 'vue-recaptcha';

export default {
  name: 'Login',

  components: {
    VueRecaptcha,
  },

  data() {
    return {
      loading: false,
      captchaVerified: false,
      username: '',
      password: '',
      errors: null,
      recaptchaStorageKey: '',
      storeError: this.$store.state.errors.auth.text,
    };
  },

  mounted() {
    if (localStorage.getItem(this.$config.tokenStorage.name) !== '') {
      const tokenStorage = JSON.parse(localStorage.getItem(this.$config.tokenStorage.name));
      if (!_.isEmpty(tokenStorage)) {
        this.$router.push('/admin');
      }
    }
    this.recaptchaStorageKey = this.$config.recaptchaStorageKey;
  },

  methods: {
    onCaptchaVerified(recaptchaToken) {
      axios.post(`${this.$config.app_api.host}${this.$config.app_api.prefix}re-captcha/verify`, {
        'g-recaptcha-response': recaptchaToken,
      })
        .then(() => {
          this.captchaVerified = true;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    onCaptchaExpired() {
      this.captchaVerified = false;
      if (this.$refs.recaptcha) this.$refs.recaptcha.reset();
    },
    isFormValid() {
      if (!this.username) {
        this.errors = 'Username field is required.';
        return false;
      }
      if (!this.password) {
        this.errors = 'Password field is required.';
        return false;
      }
      return true;
    },
    login() {
      if (this.loading) return;
      if (!this.isFormValid()) return;
      this.loading = true;
      axios.post(`${this.$config.app_api.host}${this.$config.app_api.prefix}login`, {
        username: this.username,
        password: this.password,
      })
        .then((response) => {
          if (response.data['google2fa_required']) {
            this.$store.commit('user/setTimeData', {
              username: this.username,
              password: this.password,
            });
            this.$router.push('two-factor-authentication');
            return;
          }
          if (response.data.access_token) {
            this.$store.commit('errors/setAuthError', '');
            localStorage.setItem(this.$config.tokenStorage.name, JSON.stringify(response.data));
            this.$store.commit('user/storeAccessToken', response.data.access_token);
            this.$assignAxiosHeaders(response.data.access_token);

            const userData = response.data.user;
            userData.roles.forEach((element, index) => {
              userData.roles[index].permissions = element.permissions.map(item => ({
                id: item.id,
                name: item.name,
              }));
            });
            localStorage.setItem(this.$config.userStorage.name, JSON.stringify(userData));
            this.$store.commit('user/setInfo', userData);
            this.$router.push('/admin');
          } else if (response.data.message) {
            this.errors = response.data.message;
          } else {
            this.errors = 'Server error';
          }
        })
        .catch((e) => {
          this.errors = e.response.data.message;
          console.error(e.response.data.message);
        })
        .finally(() => {
          this.onCaptchaExpired();
          this.loading = false;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// Login.vue?1dddfaac